import {
  ComponentStructure,
  Description,
  Image,
  StyledButton,
  Title
} from './GenericError.styles'
import { GenericErrorProps } from './GenericError.types'

const ERROR_IMAGE_URL =
  'https://s3.amazonaws.com/yes.network/static-files/unexpected-error.png'

const GenericError = ({
  des,
  complement,
  url,
  onClick,
  btnLabel
}: GenericErrorProps) => {
  return (
    <ComponentStructure>
      <Image src={ERROR_IMAGE_URL} />
      <Title>{des}</Title>
      <Description>{complement}</Description>
      {url && (
        <a href={url}>
          <StyledButton>{btnLabel}</StyledButton>
        </a>
      )}
      {onClick && !url && (
        <StyledButton onClick={onClick}>{btnLabel}</StyledButton>
      )}
    </ComponentStructure>
  )
}

export default GenericError
